import { render, staticRenderFns } from "./EditRegionComponent.vue?vue&type=template&id=05901b08&"
import script from "./EditRegionComponent.vue?vue&type=script&lang=js&"
export * from "./EditRegionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports